import React, { useEffect } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { useOutletContext } from 'react-router-dom';

interface ProtectedRouteProps {
  element: React.ComponentType<any>;
  [key: string]: any;
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ element: Element, ...rest }) => {
  const { isLoading: auth0Loading, isAuthenticated, loginWithRedirect } = useAuth0();
  const context = useOutletContext();

  useEffect(() => {
    if (!auth0Loading && !isAuthenticated) {
      loginWithRedirect();
    }
  }, [auth0Loading, isAuthenticated, loginWithRedirect]);

  if (!auth0Loading && isAuthenticated) {
    return <Element {...rest} {...(context as any)} />;
  }

  return <div>Loading...</div>;
};